import { itwApi } from "@application/api/middlewares/api";
const config = {
    headers: {
        "Content-Type": "multipart/form-data",
    },
};
const uploadFile = async (folderName, file) => {
    const formData = new FormData();
    if (file) {
        formData.append("file", file);
    }
    const response = await itwApi.post(`/VehicleDetail/${folderName}`, formData, config);
    return response.data;
};
const uploadFileAPI = {
    uploadFile,
};
export default uploadFileAPI;
